import {Component, OnDestroy, OnInit} from "@angular/core";
import {NotificationService} from "../notification.service";
import {ToastService} from "../../../app/core/toast.service";

@Component({
  selector: 'app-notifications-items',
  template: `
    <ion-list>
      <ion-list-header>{{ 'profile.notifications' | translate }}</ion-list-header>
      <ion-item>
        <ion-label stacked>{{ 'profile.get_product_updates' | translate }}</ion-label>
        <ion-select [(ngModel)]="newsletterOptIn"
                    (ngModelChange)="updateNewsletterStatus($event)"
                    placeholder="{{ 'profile.get_product_updates' | translate }}"
        >
          <ion-option [value]="1">{{ 'profile.yes_product_updates' | translate }}</ion-option>
          <ion-option [value]="0">{{ 'profile.no_product_updates' | translate }}</ion-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label stacked>{{ 'profile.get_email_notifications' | translate }}</ion-label>
        <ion-select [(ngModel)]="emailOptIn"
                    (ngModelChange)="updateEmailStatus($event)"
                    placeholder="{{ 'profile.get_email_notifications' | translate }}"
        >
          <ion-option [value]="1">{{ 'profile.yes_email_notifications' | translate }}</ion-option>
          <ion-option [value]="0">{{ 'profile.no_email_notifications' | translate }}</ion-option>
        </ion-select>
      </ion-item>
    </ion-list>
  `,
})
export class NotificationsItemsComponent implements OnInit, OnDestroy {
  newsletterStatusSub;
  emailStatusSub;
  newsletterOptIn;
  emailOptIn;

  constructor(private notificationService: NotificationService,
              private toast: ToastService) {
  }

  ngOnInit() {
    this.newsletterStatusSub = this.notificationService.getNewsletterStatus()
      .subscribe(status => this.newsletterOptIn = status.is_subscribed === null ? null : +status.is_subscribed);

    this.emailStatusSub = this.notificationService.getEmailStatus()
      .subscribe(status => this.emailOptIn = status.is_subscribed === null ? null : +status.is_subscribed);
  }

  ngOnDestroy() {
    this.newsletterStatusSub.unsubscribe();
    this.emailStatusSub.unsubscribe();
  }

  updateNewsletterStatus(val) {
    let obs = val ? this.notificationService.subscribeToNewsletter()
      : this.notificationService.unsubscribeFromNewsletter();
    obs.subscribe(res => this.toast.show(res.message));
  }

  updateEmailStatus(val) {
    let obs = val ? this.notificationService.subscribeToEmail()
      : this.notificationService.unsubscribeFromEmail();
    obs.subscribe(res => this.toast.show(res.message));
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/notifications-items/notifications-items.component.ts